import { Grid } from "@mui/material";
import { PricingListSubHeader, PricingFormDivider } from "../../../styles";
import { useTranslation } from "react-i18next";
import FormTable from "../../../../../../common/components/functional/formTable/FormTable";
import { useContext } from "react";
import { AccessRightContext } from "../../../../../user/AccessRightProvider";

interface Props {
  generalPricingDataArray: any[];
  tesPricingDataArray: any[];
  onOpenModal: (id?: string) => void;
}

const PricingTablesSection = ({
  generalPricingDataArray,
  tesPricingDataArray,
  onOpenModal,
}: Props) => {
  const { t } = useTranslation("customers");
  const { canEditContract } = useContext(AccessRightContext);
  const generalPicingSettingsExist = generalPricingDataArray?.length > 0;
  return (
    <>
      <PricingFormDivider />
      <Grid container sx={{ marginLeft: "1rem" }}>
        <PricingListSubHeader>
          {t("contract.generalPricingShort")}
        </PricingListSubHeader>
      </Grid>
      <Grid item sx={{ width: "100%" }}>
        <FormTable
          data={generalPricingDataArray}
          handleOpenEditModal={() => onOpenModal("general")}
          addButtonLabel={
            generalPicingSettingsExist ? null : t("contract.addGeneralPricing")
          }
        />
      </Grid>
      {!generalPicingSettingsExist && <PricingFormDivider />}
      <Grid container sx={{ marginLeft: "1rem", marginTop: "1rem" }}>
        <PricingListSubHeader>{t("common:tes")}</PricingListSubHeader>
      </Grid>
      <Grid item sx={{ width: "100%" }}>
        <FormTable
          disableEditRow={!canEditContract}
          data={tesPricingDataArray.sort((a, b) => a.id.localeCompare(b.id))}
          handleOpenEditModal={(_, id) => {
            onOpenModal(id);
          }}
          addButtonLabel={t("common:addTes")}
        />
      </Grid>
    </>
  );
};

export default PricingTablesSection;
